(function TripSummaryTransferDetails($, Adzuki)
{
	'use strict';

	const formId = 'savetransportationcomponent-';

	const component = {
		emits: [
			'remove-transfer',
		],
		inject: [
			'getFaIconStyle',
		],
		props: {
			componentId: {
				type   : String,
				default: 'new',
			},
			datesDisplayed: {
				type   : Boolean,
				default: true,
			},
			datesRequired: {
				type   : Boolean,
				default: true,
			},
			direction: {
				type   : String,
				default: 'departure',
			},
			index: {
				type   : Number,
				default: 1,
			},
			locationTypes: {
				type   : Array,
				default: [],
			},
			transferCompany: {
				type   : String,
				default: '',
			},
			transfer: {
				type   : Object,
				default: null,
			},
		},
		template: '#ts-transfer-details',
		data() {
			return {
				autoArrivalDate: null,
			};
		},
		computed: {
			// TS-391 (QA round 2). Derived, not stored: "auto" means the arrival still
			// holds exactly the date we copied in. A stored flag only cleared when the
			// arrival picker emitted `changed`, so any other way the arrival changed
			// left it stuck on auto and the next departure change overwrote the
			// advisor's date -- QA saw that on rail and transfers.
			arrivalAutoFilled() {
				return Boolean(this.transfer.arrival_date) && this.transfer.arrival_date === this.autoArrivalDate;
			},
			directionLabel() {
				return this.direction === 'departure' ? 'Departure' : 'Return';
			},
			directionVerb() {
				return this.direction === 'departure' ? 'Departing' : 'Arriving';
			},
			formId() {
				return formId + this.direction + '-' + this.index;
			},
			formName() {
				return 'form_component_data[SaveTransportationComponent][' + this.direction + '][' + this.index + ']';
			},
		},
		methods: {
			// TS-391. Copies the departure date into an EMPTY or still-auto-filled
			// arrival on a new leg, and marks it, so the template can say so -- an
			// overnight leg used to ship with the wrong arrival date unless the advisor
			// noticed. An arrival the advisor typed is never overwritten.
			departureDateChanged(date) {
				if (this.componentId !== 'new') {
					return;
				}

				if (!date) {
					return;
				}

				if (this.transfer.arrival_date && !this.arrivalAutoFilled) {
					return;
				}

				const departureDate = moment(date).format('YYYY-MM-DD');

				this.transfer.arrival_date = departureDate;
				this.autoArrivalDate = departureDate;
			},
			formatDate(date) {
				return moment(date).format('MM/DD/YYYY');
			},
			formatTime(time) {
				return moment(time).format('h:mm a');
			},
			removeTransfer() {
				Adzuki.CustomConfirm.destructive({
					title           : 'Remove this transfer?',
					body            : 'Its details will be removed from this component.',
					confirm_btn_text: 'Remove transfer',
					confirm         : () => {
						this.$emit('remove-transfer', this.direction, this.index);
					},
				});
			},
		},
		mounted() {
			// nothing to do here
		},
	};

	Adzuki.VueComponents.TripSummaryTransferDetails = component;
}(jQuery, window.Adzuki || {}));
